import BRTLogo from '@loyal_images/orders/pedido_brasil_telecom.jpg'
import ClaroLogo from '@loyal_images/orders/pedido_claro.jpg'
import CompraPontosLogo from '@loyal_images/orders/pedido_compra_pontos.jpg'
import DoacaoLogo from '@loyal_images/orders/pedido_doacao.jpg'
import NextelLogo from '@loyal_images/orders/pedido_nextel.jpg'
import OiLogo from '@loyal_images/orders/pedido_oi.jpg'
import PagueContasLogo from '@loyal_images/orders/pedido_pague_conta.jpg'
import ShellLogo from '@loyal_images/orders/pedido_shell.jpg'
import TimLogo from '@loyal_images/orders/pedido_tim.jpg'
import ViagemLogo from '@loyal_images/orders/pedido_viagem.jpg'
import VivoLogo from '@loyal_images/orders/pedido_vivo.jpg'
import Recarga from '@loyal_images/orders/mobile.png'
import InvoiceCredit from '@loyal_images/orders/credito_em_fatura.png'

export const VENDOR = {
  SHELL: { ID: 117, IMAGEURL: ShellLogo },
  SMILES: { ID: 21185, IMAGEURL: ViagemLogo },
  PURCHASEPOINTS: { ID: 61594, IMAGEURL: CompraPontosLogo },
  PAYBILLS: { ID: 21188, IMAGEURL: PagueContasLogo },
  DONATION: { ID: 54, IMAGEURL: DoacaoLogo },
  CELLPHONERECHARGE: { ID: (parseInt(process.env.REACT_APP_VENDOR_RECHARGE) || 71), IMAGEURL: Recarga },
  DEFAULTCELLPHONERECHARGE: { ID: 71, IMAGEURL: Recarga },
  INVOICECREDIT: { ID: 72013, IMAGEURL: InvoiceCredit }
}

export const OPERATORS = {
  BRT: { description: 'Brasil Telecom', IMAGEURL: BRTLogo },
  CLARO: { description: 'Claro', IMAGEURL: ClaroLogo },
  NEXTEL: { description: 'Nextel', IMAGEURL: NextelLogo },
  OI: { description: 'Oi', IMAGEURL: OiLogo },
  TIM: { description: 'Tim', IMAGEURL: TimLogo },
  VIVO: { description: 'Vivo', IMAGEURL: VivoLogo }
}
export default {
  VENDOR,
  OPERATORS
}



// WEBPACK FOOTER //
// ./src/features/ProductImage/constants.js